import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "visible.icon",
  "use": "visible.icon-usage",
  "viewBox": "-7343.4 -4612 30.8 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-7343.4 -4612 30.8 21\" id=\"visible.icon\"><path d=\"M16.4,4.5A16.558,16.558,0,0,0,1,15a16.543,16.543,0,0,0,30.8,0A16.558,16.558,0,0,0,16.4,4.5Zm0,17.5a7,7,0,1,1,7-7A7,7,0,0,1,16.4,22Zm0-11.2A4.2,4.2,0,1,0,20.6,15,4.194,4.194,0,0,0,16.4,10.8Z\" transform=\"translate(-7344.4 -4616.5)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/visible.icon.svg
// module id = dU70
// module chunks = 13